import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */
export class TrackingInstantOfferPageMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {Object} param.fromPageTrackingJsonToTrackingDataValueObjectMapper
   */
  constructor({config, fromPageTrackingJsonToTrackingDataValueObjectMapper}) {
    super()

    this._config = config
    this._fromPageTrackingJsonToTrackingDataValueObjectMapper = fromPageTrackingJsonToTrackingDataValueObjectMapper
    this._C2B_FLOW_BY_ORIGINS = config.get('tracking').C2B_FLOW_BY_ORIGINS
  }

  /**
   * @param {Object} param
   * @param {String} param.page
   * @param {String} param.culture
   * @param {Object} param.data
   * @param {Object} param.data.ad
   * @param {String} param.data.ad.id
   * @param {String} param.data.formName
   * @param {Object} param.data.instantOffer
   * @param {String} param.data.instantOffer.id
   * @param {Number} param.data.instantOffer.priceRecommended
   * @param {String} param.data.title
   */

  _getProducts = adId =>
    adId
      ? [
          {
            id: adId,
            category: 'ads',
            price: 0,
            quantity: 0
          }
        ]
      : []

  map({page, culture, data}) {
    const {
      ad: {id: adId},
      instantOffer: {id: ioId, priceRecommended},
      origin,
      title,
      pageName
    } = data

    const c2bFlow = this._C2B_FLOW_BY_ORIGINS?.[origin]

    const trackingData = {
      io_id: ioId,
      io_price: priceRecommended,
      products: this._getProducts(adId),
      page_name: pageName,
      title,
      ...(c2bFlow && {c2b_flow: c2bFlow})
    }

    if (adId) {
      trackingData.ad_id = adId
    }

    return this._fromPageTrackingJsonToTrackingDataValueObjectMapper
      .setParams({
        page,
        culture
      })
      .map(trackingData)
  }
}
